import { inject, Service, provideAppInitializer } from '@angular/core';
import { environment } from 'src/environment/environment';
import { WINDOW } from '../../providers/window/window.provider';
import { ScriptLoader } from '../load-script';
import { getFlavour } from '../web-config/web-config.helper';

@Service()
export class ImagesService {
  #window = inject(WINDOW);
  static imagesPath = '/assets/images/';
  static favIcon = {
    32: 'favicon/favicon-32x32.png',
    16: 'favicon/favicon-16x16.png',
    apple: 'favicon/apple-touch-icon.png',
  };
  static slides = [
    `${ImagesService.imagesPath}login/halo-slide-1.png`,
    `${ImagesService.imagesPath}login/halo-slide-2.png`,
  ];
  static background = `${ImagesService.imagesPath}login/left_bg.png`;
  static logos = {
    logo: `${ImagesService.imagesPath}logos/logo.svg`,
    icon: `${ImagesService.imagesPath}logos/icon.svg`,
  };

  checkImageExistsHead(url: string): Promise<boolean> {
    if (url === ImagesService.background) {
      return Promise.resolve(false);
    }
    return this.#window
      .fetch(url, { method: 'HEAD' })
      .then((response) => response.ok)
      .catch(() => false);
  }

  async verifyFavIcon() {
    const staticUrl = environment.baseUrls.static;
    const flavour = getFlavour();
    const localPath = `/assets/flavours/${flavour}/`;
    const s3Path = `${staticUrl}/static/flavours/${flavour}/`;
    const localIcon = `${localPath}${ImagesService.favIcon[16]}`;
    const s3Icon = `${s3Path}${ImagesService.favIcon[16]}`;
    if (await this.checkImageExistsHead(localIcon)) {
      this.fetchFavIcon(localPath);
    } else if (await this.checkImageExistsHead(s3Icon)) {
      this.fetchFavIcon(s3Path);
    }
  }

  async fetchFavIcon(path: string) {
    const insert = { beforeEnd: 'head' };
    const type = 'image/png';
    const rel = 'icon';
    const appleIcon: HTMLLinkElement = this.#window.document.getElementById('apple-touch-icon') as HTMLLinkElement;
    const favicon32: HTMLLinkElement = this.#window.document.getElementById('favicon-32x32') as HTMLLinkElement;
    const favicon16: HTMLLinkElement = this.#window.document.getElementById('favicon-16x16') as HTMLLinkElement;
    if (appleIcon) {
      appleIcon.remove();
      const rel = 'apple-touch-icon';
      const sizes = '180x180';
      const id = 'apple-touch-icon';
      ScriptLoader.loadScript('link', { rel, sizes, href: path + ImagesService.favIcon.apple, id }, insert);
    }
    if (favicon32) {
      favicon32.remove();
      const sizes = '32x32';
      const id = 'favicon-32x32';
      ScriptLoader.loadScript('link', { rel, type, sizes, href: path + ImagesService.favIcon[32], id }, insert);
    }
    if (favicon16) {
      favicon16.remove();
      const sizes = '16x16';
      const id = 'favicon-16x16';
      ScriptLoader.loadScript('link', { rel, type, sizes, href: path + ImagesService.favIcon[16], id }, insert);
    }
  }
}

export const FavIconProvider = provideAppInitializer(() => {
  return inject(ImagesService).verifyFavIcon();
});
